import React, { useState } from 'react';

export default function ForBrands() {
  const [ctaHover, setCtaHover] = useState(false);

  return (
    <section id="brands" className="section-pad" style={{ padding: '120px 56px', background: 'var(--off-white)', borderTop: '1px solid var(--border)' }}>
      <div className="section-grid-2" style={{ maxWidth: '1280px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
        <div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '20px' }}>
            For Brands
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 900, lineHeight: 1, color: 'var(--ink)', marginBottom: '28px', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
            Launch Campaigns<br />That Actually<br />Convert
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 400, color: 'var(--ink-muted)', lineHeight: 1.8, marginBottom: '20px' }}>
            We partner with brands at every stage — from funded startups to global enterprises — crafting influencer strategies grounded in data and executed by creators your audience already trusts.
          </p>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--ink-muted)', lineHeight: 1.8, marginBottom: '40px' }}>
            Tell us about your campaign goals and we'll put together the right creator strategy for your brand.
          </p>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '14px 36px',
              background: ctaHover ? 'var(--accent-dark)' : 'var(--accent)',
              color: '#0a0a0a',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onMouseEnter={() => setCtaHover(true)}
            onMouseLeave={() => setCtaHover(false)}
          >
            Start a Campaign →
          </button>
        </div>

        <div style={{ background: 'var(--ink)', padding: '52px 44px', borderRadius: '4px' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px, 2.5vw, 36px)', fontWeight: 700, color: 'var(--white)', lineHeight: 1.35, marginBottom: '28px', fontStyle: 'italic' }}>
            "The right creator, for the right audience, at the right moment."
          </div>
          <div style={{ width: '40px', height: '3px', background: 'var(--accent)', marginBottom: '20px', borderRadius: '2px' }} />
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.8 }}>
            Our matching process is built on audience alignment, brand values, and content authenticity — not just follower counts.
          </div>
        </div>
      </div>
    </section>
  );
}
